import React from "react"
import Loader from "./Loader"


export const JsStillRendering = () => {

    return <React.Fragment>
       
            <React.Fragment>
                <Loader />
            </React.Fragment>
       
    </React.Fragment >
}